// extracted by mini-css-extract-plugin
export default {"wrapper":"logoSeed_wrapper__sHJiJ","logoText":"logoSeed_logoText__QyLL5","pic":"logoSeed_pic__E8UDH","logoWhite":"logoSeed_logoWhite__lPtIL","logoLink":"logoSeed_logoLink__CWbZE"};